var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "input-group mb-3" }, [
        _c("div", { staticClass: "custom-file" }, [
          _c("input", {
            staticClass: "custom-file-input",
            attrs: {
              id: "file-signature-selector",
              type: "file",
              accept: "image/png"
            },
            on: {
              change: function($event) {
                return _vm.uploadFile($event)
              }
            }
          }),
          _c(
            "label",
            {
              staticClass: "custom-file-label",
              attrs: { for: "file-signature-selector" }
            },
            [_vm._v(" " + _vm._s(_vm.fileName || "Seleccionar archivo") + " ")]
          )
        ])
      ])
    ]),
    _vm.errorSize
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [_vm._v(" Ups! la imagen debe medir 440 x 320px ")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }